__turbopack_context__.v({
  "scrollable": "NiJjra_scrollable",
  "scrollableMaskEnd": "NiJjra_scrollableMaskEnd",
  "scrollableMaskStart": "NiJjra_scrollableMaskStart",
  "scrollableWrapper": "NiJjra_scrollableWrapper",
  "visible": "NiJjra_visible",
});
